import styled from "styled-components"
import { useT } from "react-polyglot-hooks"
import Image from "next/legacy/image"
import Typography from "../styled/Typography"
import Col from "../styled/Grid/Col"
import { Row, SectionContainer, TitleWrapper, WhiteSection } from "../styled/Grid"

const Item = styled(Col)`
  margin-bottom: 25px;
  text-align: center;
  &:last-child {
    margin-bottom: 0;
  }
  @media ${({ theme }) => theme.breakpoints.md} {
    margin-bottom: 0;
  }
`

const Title = styled(Typography)`
  margin-top: 15px;
  margin-bottom: 10px;
`

export default function Features() {
  const t = useT()

  return (
    <WhiteSection>
      <SectionContainer>
        <TitleWrapper>
          <Typography variant="title2" weight="medium" center space el="h3">
            {t("common.renting-features.title")}
          </Typography>
        </TitleWrapper>
        <Row>
          <Item xs={12} md={4}>
            <Image alt="Support" src="/f_svg/static/support_2" height={48} width={48} />
            <Title variant="title4" weight="medium" center>
              {t("common.renting-features.1.title")}
            </Title>
            <Typography variant="small" weight="light" color="skyBlue" center>
              {t("common.renting-features.1.text")}
            </Typography>
          </Item>
          <Item xs={12} md={4}>
            <Image alt="Offer" src="/f_svg/static/offer" height={48} width={48} />
            <Title variant="title4" weight="medium" center>
              {t("common.renting-features.2.title")}
            </Title>
            <Typography variant="small" weight="light" color="skyBlue" center>
              {t("common.renting-features.2.text")}
            </Typography>
          </Item>
          <Item xs={12} md={4}>
            <Image alt="Car key" src="/f_svg/static/car-key" height={48} width={48} />
            <Title variant="title4" weight="medium" center>
              {t("common.renting-features.3.title")}
            </Title>
            <Typography variant="small" weight="light" color="skyBlue" center>
              {t("common.renting-features.3.text")}
            </Typography>
          </Item>
        </Row>
      </SectionContainer>
    </WhiteSection>
  )
}
